import React from 'react';
import style from './sideScreen.module.scss';
import { setStatusBarForDarkContent, setStatusBarForLightContent } from 'acscp/mobile/device/statusBar';

declare interface SideScreenProps {
    children: any;
}

class SideScreen extends React.Component<SideScreenProps, {}> {
    componentDidMount(): void {
        setStatusBarForDarkContent();
    }

    componentWillUnmount(): void {
        setStatusBarForLightContent(); // revert
    }

    render(): JSX.Element {
        return (
            <div className={style.backdrop}>
                <div className={style.Content}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export { SideScreen };
